import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';
import { getTagsByBusinessId } from './getTagsByBusinessId';

export const addTagToTagList = createAsyncThunk(
  'tags/addTagToTicket',
  async ({ name }, { getState, dispatch, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const business_id =loginToken?.response?.user?.business_id
      const response = await axios.post(
        `${ROOT_URL}/ticket/${business_id}/tags`,
        { name },
        {
          headers: {
            'Authorization': `Bearer ${authToken}`
          }
        }
      );

      dispatch(getTagsByBusinessId());

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const addTagToTicketSlice = createSlice({
  name: 'addTagToTicket',
  initialState,
  reducers: {
    resetAddTagState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addTagToTicket.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addTagToTicket.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(addTagToTicket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  }
});

export const { resetAddTagState } = addTagToTicketSlice.actions;
export default addTagToTicketSlice.reducer; 